import { render, staticRenderFns } from "./FuneralRequest.vue?vue&type=template&id=dfad2264&scoped=true&"
import script from "./FuneralRequest.vue?vue&type=script&lang=js&"
export * from "./FuneralRequest.vue?vue&type=script&lang=js&"
import style0 from "./FuneralRequest.vue?vue&type=style&index=0&id=dfad2264&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfad2264",
  null
  
)

export default component.exports